import lazyloadHelper from "@ng-mw/shared-react-components/lazyloadHelper"

const { WithSuspense: Onboarding } = lazyloadHelper(
    () => import(/* webpackChunkName: "Onboarding" */ "./AppOnboarding"),
)
const { WithSuspense: AppRating } = lazyloadHelper(
    () => import(/* webpackChunkName: "Onboarding" */ "./AppRating"),
)
const { WithSuspense: AppUpgrade } = lazyloadHelper(
    () => import(/* webpackChunkName: "Onboarding" */ "./AppUpgrade"),
)
const { WithSuspense: AppNews } = lazyloadHelper(
    () => import(/* webpackChunkName: "Registration" */ "./AppNews"),
)
const { WithSuspense: ForcedUpgrade } = lazyloadHelper(
    () => import(/* webpackChunkName: "Forced" */ "./ForcedUpgrade"),
)
const { WithSuspense: Registration } = lazyloadHelper(
    () => import(/* webpackChunkName: "Registration" */ "./Registration"),
)
const { WithSuspense: RegistrationCorporate } = lazyloadHelper(
    () => import(/* webpackChunkName: "RegistrationCorporate" */ "./RegistrationCorporate"),
)

export {
    Onboarding,
    AppRating,
    AppUpgrade,
    AppNews,
    ForcedUpgrade,
    Registration,
    RegistrationCorporate,
}
